import { Component } from '@angular/core';
import {
  NgbDropdown,
  NgbDropdownToggle,
  NgbDropdownMenu,
  NgbDropdownButtonItem,
  NgbDropdownItem,
  NgbDropdownAnchor,
} from '@ng-bootstrap/ng-bootstrap';
import { FormlyModule } from '@ngx-formly/core';

import { FormlyFieldBaseComponent } from '../formly-field-base.component';

@Component({
  selector: 'app-formly-button',
  templateUrl: './formly-button.component.html',
  styleUrl: './formly-button.component.scss',
  imports: [
    NgbDropdown,
    NgbDropdownToggle,
    NgbDropdownMenu,
    NgbDropdownButtonItem,
    NgbDropdownItem,
    NgbDropdownAnchor,
    FormlyModule,
  ],
})
export class FormlyButtonComponent extends FormlyFieldBaseComponent {
  defaultOptions = {
    props: { type: 'button', btnClass: 'primary' },
  };

  // A double click is stopped before it reaches these handlers by the app-wide
  // ClickGuardService, which keeps the button greyed out until the work it started has
  // finished - so there is no cooldown of its own here.
  onClick(event: any) {
    if (this.props.onClick) {
      this.props.onClick(event);
    }
  }

  onDropdownClick(dropdown: { onClick?: (event: any) => void }, event: any) {
    dropdown.onClick?.(event);
  }
}
